import { usePetitionEditPageData } from 'src/app/pages/petitionEditV2/pageContext';

import { TIPS_CONFIGS } from '../../../constants';
import type { TipCardConfig } from '../../../types';

type PartialTipCardConfig = Omit<TipCardConfig, 'url' | 'onClick'>;

export function useVerifyStrengthTips(): PartialTipCardConfig[] {
	const {
		data: { petition },
	} = usePetitionEditPageData();

	return TIPS_CONFIGS.filter((strengthTip) => strengthTip.verifyFunction(petition));
}
